/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams, useParams } from "react-router";
import {
  Button,
  Form,
  SelectionField,
  MultiSelectionField,
  InputField,
  MultiSelectField,
  RadioInputField,
  TextAreaField,
  RichTextField,
  VisualizationAttr,
  Spinner,
  
  
} from "@/commons/components";
import {
  ALLOWED_PERMISSIONS,
  findAllowedPermission,
} from "@/commons/constants/allowedPermission";
import cleanFormData from "@/commons/utils/cleanFormData";
import saveJadwalKelas from '../services/saveJadwalKelas'

import { notifyError, notifySuccess} from "@/commons/utils/toaster";
import * as Layouts from "@/commons/layouts";

const FormTambahJadwalKelas = ({ 
	ruangan
, 	hari
 }) => {
  const { 
    control, 
    handleSubmit,
  } = useForm({ defaultValues: ruangan })
  
  
  const { kelasId } = useParams()
  
  const navigate = useNavigate()
  
  const tambah = (data) => {
    const cleanData = cleanFormData(data)
    saveJadwalKelas({
	  kelasId: kelasId,
      ...cleanData,
    })
    .then(({ data: { data } }) => {
     navigate(`/kelas/${kelasId}`)
  	notifySuccess(`Save Jadwal Kelas berhasil!`);
    })
    .catch((error) => {
      console.error(error);
          notifyError(error);
    });
  }
  
  
  return (
	<div>
	  <Layouts.FormComponentLayout
		  title="Tambah Jadwal Kelas" 
		  onSubmit={handleSubmit(tambah)}
	
	    vas={[
		  ]}
	
		  formFields={[
			  
			  <Controller
			    key="mulai"
		        name="mulai"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
				    type="time"
		            label="Waktu Mulai"
		            placeholder="Masukkan waktu mulai"
		            defaultValue={ruangan.mulai}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />
	,
			  
			  <Controller
			    key="selesai"
		        name="selesai"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
				    type="time"
		            label="Waktu Selesai"
		            placeholder="Masukkan waktu selesai"
		            defaultValue={ruangan.selesai}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />
		  ,
	
		  
		  <Controller
		    key="ruanganId"
	        name="ruanganId"
	        control={control}
	        render={({ field, fieldState }) => (
					<SelectionField
				
	            label="Ruangan"
	            options={ruangan}
				optionKey="ruanganId"
	            optionLabel="ruangan"
	            placeholder="Masukkan ruangan"
					fieldState={fieldState}
					defaultValue={ruangan.ruanganId}
	            {...field}
					isRequired={false}
	          />
	
	        )}
	      />
	,
		  
		  <Controller
		    key="hari"
	        name="hari"
	        control={control}
	        render={({ field, fieldState }) => (
					<SelectionField
				
	            label="Hari"
	            options={hari}
				optionKey="hari"
	            optionLabel="hari"
	            placeholder="Masukkan hari"
					fieldState={fieldState}
					defaultValue={ruangan.hari}
	            {...field}
					isRequired={false}
	          />
	
	        )}
	      />
		  ]}
	
		  itemsEvents={[
				<Button id="_8fD8gCuREfCz9KF7E6i0TQ" key="Tambah" type="submit" variant="primary">Tambah</Button>
	    ]}
	  />
	    
	</div>
  )
}

export default FormTambahJadwalKelas
